var map = {
	"./pages/companies/companies.module": [
		"../../../../../src/app/pages/companies/companies.module.ts"
	],
	"./pages/dashboard/dashboard.module": [
		"../../../../../src/app/pages/dashboard/dashboard.module.ts"
	],
	"./pages/pending-registration/pending-registration.module": [
		"../../../../../src/app/pages/pending-registration/pending-registration.module.ts",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "../../../../../src async recursive";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src async
// module id = ../../../../../src async recursive
// module chunks = 2